// extracted by mini-css-extract-plugin
export var boxItems = "_cl-1";
export var boxItemsLg = "_cl-2";
export var button = "_cl-7";
export var buttonHoverless = "_cl-9";
export var buttonLg = "_cl-8";
export var filterGroupBox = "_cl-0";
export var icon = "_cl-3";
export var iconSecondary = "_cl-6";
export var iconWrapper = "_cl-4";
export var iconWrapperLg = "_cl-5";
export var truncatedLabel = "_cl-a";